document.addEventListener("DOMContentLoaded", () => {
  const cartApiUrl = "/cart.js"; // Shopify's cart API endpoint

  // Move updateCartState declaration to the top
  const updateCartState = () => {
    const currentState = history.state || {};
    history.replaceState(
      { 
        ...currentState, 
        cartUpdateTime: Date.now() 
      }, 
      ''
    );
  };

  const updateButtonState = (button, { disabled, text, addClasses = [], removeClasses = [], clickHandler }) => {
    if (!button) return;

    button.disabled = disabled;
    if (disabled) {
      button.setAttribute("data-disabled", "disabled");
    } else {
      button.removeAttribute("disabled");
    }

    // Update classes
    addClasses.forEach((className) => button.classList.add(className));
    removeClasses.forEach((className) => button.classList.remove(className));

    button.innerHTML = `<span>${text}</span>`;
    button.onclick = clickHandler || null;
  };

  const setAddedToCartButton = (button) => {
    updateButtonState(button, {
      disabled: true,
      text: "Added to Cart",
      addClasses: ["added-to-cart"],
      removeClasses: ["loading", "go-to-cart"],
    });
  };

  const setGoToCartButton = (button) => {
    updateButtonState(button, {
      disabled: false,
      text: "Added to Cart",
      addClasses: ["go-to-cart"],
      removeClasses: ["added-to-cart", "loading"],
      clickHandler: () => {
        updateButtonState(button, {
          disabled: true,
          text: "Redirecting...",
          addClasses: ["go-to-cart"],
        });
        setTimeout(() => {
          window.location.href = "/cart";
        }, 500);
      },
    });
  };

  const resetAddToCartButton = (button) => {
    updateButtonState(button, {
      disabled: false,
      text: "Add to Cart",
      removeClasses: ["added-to-cart", "go-to-cart", "loading"],
    });
  };

  const updateCartButtons = async () => {
    try {
      const response = await fetch(cartApiUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error("Failed to fetch cart contents");

      const cart = await response.json();
      const cartItems = new Set(cart.items.map((item) => item.variant_id));

      document.querySelectorAll("form[action='/cart/add']").forEach((form) => {
        const variantIdInput = form.querySelector("input[name='id']");
        const submitButton = form.querySelector("button[type='submit']");
        if (variantIdInput && submitButton) {
          const variantId = parseInt(variantIdInput.value, 10);
          if (cartItems.has(variantId)) {
            setGoToCartButton(submitButton);
          } else {
            resetAddToCartButton(submitButton);
          }
        }
      });
    } catch (error) {
     }
  };

  const handleFormSubmit = async (form) => {
    const formData = new FormData(form);
    const submitButton = form.querySelector("button[type='submit']");
    const loadingSpinner = form.querySelector(".loading__spinner");

    if (submitButton) {
      if (loadingSpinner) loadingSpinner.classList.remove("hidden");
      updateButtonState(submitButton, {
        disabled: true,
        text: "Adding...",
        addClasses: ["loading"],
      });
    }

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (!response.ok) throw new Error("Failed to add item to cart");

      const contentType = response.headers.get("Content-Type");
      if (contentType?.includes("application/json")) {
        await response.json();
      }

      if (submitButton) {
        setAddedToCartButton(submitButton);
        setTimeout(() => setGoToCartButton(submitButton), 3000);
      }

      // Immediately update cart buttons after adding an item
      await updateCartButtons();
      updateCartState(); // Add state update after successful cart modification
    } catch (error) {
       if (submitButton) resetAddToCartButton(submitButton);
    } finally {
      if (loadingSpinner) loadingSpinner.classList.add("hidden");
    }
  };

  document.querySelectorAll("form[action='/cart/add']").forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      handleFormSubmit(form);
    });
  });

  // Initial button update on page load
  updateCartButtons();
  updateCartState();

  // Add navigation state handlers
  window.addEventListener('popstate', () => {
    updateCartButtons();
  });

  window.addEventListener('pageshow', (event) => {
    // Update on back/forward navigation including bfcache restore
    if (event.persisted) {
      updateCartButtons();
    }
  });
});




document.addEventListener('DOMContentLoaded', () => {
  // Find all cart icons and submit buttons
  const cartIcons = document.querySelectorAll('[id^="cart-icon-bubble"]');
  const submitButtons = document.querySelectorAll('.product-form__submit');

  function updateAllCartUI(count) {
    // Get all cart count elements across the page
    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    
    requestAnimationFrame(() => {
      cartCountBubbles.forEach(bubble => {
        const countSpan = bubble.querySelector('span[aria-hidden="true"]');
        const ariaSpan = bubble.querySelector('.visually-hidden');

        // Update visible count
        if (countSpan) {
          countSpan.innerHTML = count;
          countSpan.setAttribute('data-count', count);
        }

        // Update aria label
        if (ariaSpan) {
          ariaSpan.innerHTML = `${count} item${count !== 1 ? 's' : ''}`;
        }
      });

      // Verify all counts match
      const allCounts = [...document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]')]
        .map(span => parseInt(span.textContent));
      
      const mismatch = allCounts.some(spanCount => spanCount !== count);
      
      if (mismatch) {
        cartCountBubbles.forEach(bubble => {
          const countSpan = bubble.querySelector('span[aria-hidden="true"]');
          if (countSpan) countSpan.innerHTML = count;
        });
      }

      
    });
  }

  // Add click handlers
  submitButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Get count from first available counter
      const firstCounter = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      const currentCount = parseInt(firstCounter?.textContent || '0');
      const newCount = currentCount + 1;
      
      // Update all UI elements
      updateAllCartUI(newCount);

      // Verify updates after a frame
      requestAnimationFrame(() => {
        const counters = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
        const anyMismatch = [...counters].some(counter => 
          parseInt(counter.textContent) !== newCount
        );

        if (anyMismatch) {
          updateAllCartUI(newCount);
        }
      });
    });
  });
});
